<app-iota-modal [title]="updatedPerson.firstName + ' ' + updatedPerson.lastName" [modalOptions]="modalOptions" (close$)="onCancelClick()">
    <div modal-body>
        <mat-tab-group class="tabs-boxed bg-base-100">
            <mat-tab label="Generally" i18n-label>
                <div class="p-5 grid grid-cols-4 items-center break-words gap-2">
                    <span i18n>Title</span>
                    <input type="text" class="col-span-3 input input-bordered" [(ngModel)]="updatedPerson.title" />

                    <span i18n>First name</span>
                    <input type="text" class="col-span-3 input input-bordered" [(ngModel)]="updatedPerson.firstName" />

                    <span i18n>Last name</span>
                    <input type="text" class="col-span-3 input input-bordered" [(ngModel)]="updatedPerson.lastName" />

                    <span i18n>Gender</span>
                    <select class="col-span-3 select select-bordered" [(ngModel)]="updatedPerson.gender">
                        <option *ngFor="let gender of genders" [value]="gender">
                            {{ getGenderDescription(gender) }}
                        </option>
                    </select>

                    <span i18n>Position in the company</span>
                    <input type="text" class="col-span-3 input input-bordered" [(ngModel)]="updatedPerson.position" />

                    <span i18n>Department</span>
                    <input type="text" class="col-span-3 input input-bordered" [(ngModel)]="updatedPerson.department" />
                </div>
            </mat-tab>

            <mat-tab label="Kontaktinformationen" class="nav-item">
                <div class="p-5 flex flex-col gap-5">
                    <div class="flex flex-col gap-4">
                        <div class="flex flex-row justify-between items-center">
                            <h4 class="mb-0" i18n>Email</h4>
                            <button (click)="addEmail()" class="btn btn-secondary btn-circle btn-sm">
                                <iota-icon icon="plus"></iota-icon>
                            </button>
                        </div>

                        <app-email
                            *ngFor="let email of updatedPerson.emails"
                            [email]="email"
                            (save)="saveEmail($event)"
                            (delete)="deleteEmail(email, $event)"
                            (cancelEdit)="cancelEmailEditing($event)"
                            #emails
                        ></app-email>
                    </div>

                    <div class="flex flex-col gap-4">
                        <div class="flex flex-row justify-between items-center">
                            <h4 class="mb-0" i18n>Phone</h4>
                            <button (click)="addPhoneNumber()" class="btn btn-secondary btn-circle btn-sm">
                                <iota-icon icon="plus"></iota-icon>
                            </button>
                        </div>

                        <app-phone-number
                            *ngFor="let phoneNumber of updatedPerson.phoneNumbers"
                            [phoneNumber]="phoneNumber"
                            (save)="savePhoneNumber($event)"
                            (delete)="deletePhoneNumber(phoneNumber, $event)"
                            (cancelEdit)="cancelPhoneNumberEditing($event)"
                            #phoneNumbers
                        ></app-phone-number>
                    </div>

                    <div class="flex flex-col gap-2">
                        <div class="flex flex-row items-center gap-2">
                            <span class="min-w-1/4" i18n>Fax</span>
                            <input type="text" class="flex-1 input input-bordered" [(ngModel)]="updatedPerson.fax" />
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Adressen" class="nav-item">
                <app-section-header text="Adressen">
                    <div buttons>
                        <button class="btn btn-primary btn-circle btn-sm" (click)="addAddress()">
                            <iota-icon icon="plus"></iota-icon>
                        </button>
                    </div>
                </app-section-header>
                <app-address
                    *ngFor="let address of updatedPerson.addresses"
                    [showSaveButton]="!isCreation"
                    [editMode]="isCreation"
                    [showEditButton]="!isCreation"
                    [address]="address"
                    (save)="saveAddress($event)"
                    (delete)="deleteAddress($event)"
                    (editCancelled)="cancelAddressEditing(address)"
                    #addresses
                ></app-address>
            </mat-tab>
            <mat-tab label="Remarks" class="nav-item">
                <app-section-header text="Remarks" i18n-text></app-section-header>
                <app-note-list [notes]="updatedPerson.notes" (add)="addNote($event)" (delete)="deleteNote($event)"></app-note-list>
            </mat-tab>
        </mat-tab-group>
    </div>

    <div modal-footer class="flex grow justify-between">
        <div class="flex-1"></div>
        <button class="btn btn-primary" [ngClass]="{ loading: personActionLoading$ | ngrxPush }" (click)="onSaveClick()" i18n>Save</button>
    </div>
</app-iota-modal>
